export type MetaPixelFunction = (...args: unknown[]) => void;

const TEACHER_REGISTRATION_PAYLOAD = {
  content_name: "teacher",
  status: true,
} as const;

function resolveMetaPixel(
  fbq?: MetaPixelFunction,
): MetaPixelFunction | undefined {
  if (fbq) return fbq;
  if (typeof window === "undefined") return undefined;

  const browserWindow = window as Window & { fbq?: MetaPixelFunction };
  return typeof browserWindow.fbq === "function"
    ? browserWindow.fbq
    : undefined;
}

export function trackMetaTeacherRegistration(
  profile?: string | null,
  fbq?: MetaPixelFunction,
): boolean {
  if (profile !== "teacher") return false;

  const pixel = resolveMetaPixel(fbq);
  if (!pixel) return false;

  pixel("track", "CompleteRegistration", TEACHER_REGISTRATION_PAYLOAD);
  return true;
}

export function createMetaTeacherRegistrationTracker(
  fbq?: MetaPixelFunction,
): (profile?: string | null) => boolean {
  let tracked = false;

  return (profile) => {
    if (tracked) return false;

    const didTrack = trackMetaTeacherRegistration(profile, fbq);
    if (didTrack) tracked = true;
    return didTrack;
  };
}

export function trackMetaPageView(fbq?: MetaPixelFunction): boolean {
  const pixel = resolveMetaPixel(fbq);
  if (!pixel) return false;

  pixel("track", "PageView");
  return true;
}
